import { GET_ACTIVE_COUNTRIES } from '../graphql/countries'

export const Countries = client => ({
  getActiveCountries: async data =>
    await client
      .request(GET_ACTIVE_COUNTRIES, data)
      .then(results => results.activeCountries),
})
